/** @file Translate tool pointer: shared transform press with the translate gizmo. */
import type { ToolPointer } from '../../panels/viewport/viewportTypes';
import { transformIdle } from '../transform/transformIdle';
import { transformPress } from '../transform/transformPress';
import { translateGesture } from '../transform/translateGesture';

/** Free disc and X/Y axes, world-aligned. */
export const translatePointer: ToolPointer = { press: (ctx, p) => transformPress(ctx, p, 'translate', translateGesture), idle: (ctx) => transformIdle(ctx, 'translate') };
